import { ContentType } from '@sr/types';
import React from 'react';
import RichText from '../tiptap-text/RichText';

type Props = {
  content: string;
  contentType: ContentType;
  itemId: string;
  updateContent: (itemId: string, content: string) => void;
};

function Summary({ content, contentType, itemId, updateContent }: Props) {
  function updateSummary(content: string) {
    updateContent(itemId, content);
  }

  return (
    <RichText
      content={content}
      contentType={contentType}
      updateContent={updateSummary}
      itemId={itemId}
    />
  );
}

function isEqual(prev: Props, next: Props): boolean {
  return (
    prev.content === next.content &&
    prev.itemId === next.itemId &&
    prev.updateContent === next.updateContent
  );
}

export default React.memo(Summary, isEqual);
